import { PlacingOrder } from '@/widgets/PlacingOrder/ui/PlacingOrder'
import './ui/PlacingOrder.scss'
export default PlacingOrder
